import gql from 'graphql-tag';

export const WAREHOUSE_FRAGMENT = gql`
  fragment WarehouseFragment on Warehouse {
    createdAt
    createdBy
    id
    internalId
    isActive
    isLocalCarrier
    name
    updatedAt
    updatedBy
  }
`;

export const WAREHOUSE_FIND_MANY = gql`
  query WarehouseFindMany(
    $orderBy: [WarehouseOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: WarehouseWhereInput
  ) {
    WarehouseFindMany(
      orderBy: $orderBy
      skip: $skip
      take: $take
      where: $where
    ) {
      ...WarehouseFragment
    }
  }
  ${WAREHOUSE_FRAGMENT}
`;

// Note: deliberately does NOT select the "warehouse" relation field.
// WarehouseSection.warehouse is non-nullable in the schema, but the backend
// resolver returns null for it on at least some rows — Apollo then discards
// the whole response as errored. warehouseName is resolved client-side
// instead (see WarehouseSectionsComponent), matching warehouseId against the
// already-loaded warehouses list.
export const WAREHOUSE_SECTION_FIND_MANY = gql`
  query WarehouseSectionFindMany(
    $orderBy: [WarehouseSectionOrderByWithRelationInput!]
    $where: WarehouseSectionWhereInput
  ) {
    WarehouseSectionFindMany(orderBy: $orderBy, where: $where) {
      id
      name
      warehouseId
    }
  }
`;

export const WAREHOUSE_SECTION_CREATE = gql`
  mutation WarehouseSectionCreate($name: String!, $warehouseId: Int!) {
    WarehouseSectionCreate(name: $name, warehouseId: $warehouseId) {
      id
      name
      warehouseId
    }
  }
`;

export const WAREHOUSE_SECTION_UPDATE = gql`
  mutation WarehouseSectionUpdate($id: Int!, $name: String!) {
    WarehouseSectionUpdate(id: $id, name: $name) {
      id
      name
      warehouseId
    }
  }
`;

export const WAREHOUSE_SECTION_DELETE = gql`
  mutation WarehouseSectionDelete($id: Int!) {
    WarehouseSectionDelete(id: $id) {
      id
    }
  }
`;
